<template>
  <div class="form-item">
    <select
      class="select-input"
      name="selectInput"
      @change="handleInput"
      v-if="items && items.length > 0"
    >
      <option disabled selected value="">Select Option</option>
      <option v-for="(item, key) in items" :key="key" :value="item.id">{{
        item.name
      }}</option>
    </select>
    <p v-else>No items found</p>
    <small v-if="error" class="error">{{ error }}</small>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "InputBank",
  props: {
    model: null,
    placeholder: null,
    disabled: false,
    type: "text",
    items: null,
    error: null
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    handleInput(event) {
      this.$emit("input", event.target.value);
      this.$emit("getLinked", event.target.value);

    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";
.form-item {
  margin-bottom: 20px;

  .select-input {
    background: #EFEFEF;
    border-radius: 3px;
    border: none;
    width: 100%;
    padding: 10px 20px;
    height: 60px;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #727272;
  }

  input,
  .input {
    width: 100%;
    display: block;
    height: 50px;
    padding: 20px;
    font-weight: bold;
    border: 1px solid #cccccc;
  }

  .error {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/components/InputBank.vue